import { faPen } from '@fortawesome/pro-regular-svg-icons'
import { BasicEmptyState, EmptyStateWithAction } from '@scoir/empty-state'

type HighlightsEmptyStateProps = {
  canManageContent: boolean
  handleModal: () => void
}
const HighlightsEmptyState = ({ canManageContent, handleModal }: HighlightsEmptyStateProps) => {
  return canManageContent ? (
    <EmptyStateWithAction
      title="Share school highlights"
      subTitle="What makes your school special? Add five short sentences to describe unique characteristics and value proposition on your profile."
      icon={faPen}
      actionProps={{
        children: 'Edit Highlights',
        onClick: handleModal,
      }}
    />
  ) : (
    <BasicEmptyState
      title="You don’t have permission to add school highlights"
      subTitle="Contact your school’s administrator to grant you the appropriate access."
      icon={faPen}
    />
  )
}

export default HighlightsEmptyState
